import { useState, useEffect } from "react";
import { db, auth } from "../../firebase/config";
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  onSnapshot,
} from "firebase/firestore";

import Teacherheader from "../Teacherheader";
import Teachersidebar from "../Teachersidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import "./Messageallteachers.css";

interface Message {
  text: string;
  sender: string;
  timestamp?: any;
}

const Messageallteachers = () => {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState<Message[]>([]);
  const [schoolID, setSchoolID] = useState("");
  const [currentUID, setCurrentUID] = useState("");

  useEffect(() => {
    const fetchAndListen = async () => {
      const user = auth.currentUser;
      if (!user) return;

      setCurrentUID(user.uid);

      const schoolspartofSnap = await getDocs(
        collection(db, `users/${user.uid}/schoolspartof`)
      );

      if (schoolspartofSnap.empty) {
        console.error("❌ No school found in schoolspartof.");
        return;
      }

      const schoolDoc = schoolspartofSnap.docs[0];
      const id = schoolDoc.data().schoolUID;

      if (!id) {
        console.error("❌ schoolUID missing in schoolspartof doc:", schoolDoc.data());
        return;
      }

      setSchoolID(id);

      const messagesRef = collection(db, `schools/${id}/communication/main/messages`);
      const q = query(messagesRef, orderBy("timestamp", "asc"));

      const unsubscribe = onSnapshot(q, (snapshot) => {
        const updatedMessages = snapshot.docs.map((doc) => doc.data() as Message);
        setMessages(updatedMessages);
      });

      return () => unsubscribe();
    };

    fetchAndListen();
  }, []);

  const handleSend = async () => {
    const user = auth.currentUser;
    if (message.trim() === "" || !schoolID || !user) return;

    const messageData: Message = {
      text: message,
      sender: user.uid,
      timestamp: serverTimestamp(),
    };

    try {
      await addDoc(
        collection(db, `schools/${schoolID}/communication/main/messages`),
        messageData
      );
      setMessage("");
    } catch (err) {
      console.error("❌ Failed to send message:", err);
    }
  };

  return (
    <SidebarProvider>
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar left */}
        <Teachersidebar />

        {/* Right: header + content */}
        <div className="flex flex-col flex-1 overflow-hidden">
          <Teacherheader />

          {/* Main message area */}
          <div className="flex-1 overflow-y-auto p-4">
            <div className="message-board">
              <div className="message-board__container">
                <h2 className="message-board__title">📬 Teacher Message Board</h2>

                <div className="message-board__messages">
                  {messages.map((msg, index) => (
                    <div
                      key={index}
                      className={`message-board__message ${
                        msg.sender === currentUID
                          ? "message-board__message--you"
                          : "message-board__message--other"
                      }`}
                    >
                      <span>{msg.text}</span>
                    </div>
                  ))}
                </div>

                <div className="message-board__input-area">
                  <input
                    type="text"
                    className="message-board__input"
                    placeholder="Type your message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSend()}
                  />
                  <button
                    className="message-board__send-button"
                    onClick={handleSend}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Messageallteachers;
